import { useEffect, useState } from "react";
import { MessageCircle } from "lucide-react";
import { waLink } from "../../lib/clinic";

export const FloatingCTA = () => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const onScroll = () => setVisible(window.scrollY > 400);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <a
      href={waLink()}
      target="_blank"
      rel="noreferrer"
      data-testid="floating-whatsapp-cta"
      aria-label="Agendar cita por WhatsApp"
      className={`fixed z-40 bottom-6 right-6 transition-all duration-500 ${
        visible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4 pointer-events-none"
      }`}
    >
      <span className="relative flex items-center gap-2.5 bg-[hsl(var(--soft-red))] text-white pl-4 pr-5 py-3 rounded-full shadow-warm hover:bg-[hsl(var(--soft-red))]/95 hover:scale-105 transition-transform">
        <span className="absolute inset-0 rounded-full bg-[hsl(var(--soft-red))] animate-ping opacity-30" />
        <MessageCircle className="w-5 h-5 relative" />
        <span className="relative text-sm font-medium hidden sm:inline">Agenda tu cita</span>
      </span>
    </a>
  );
};
